module.exports = __webpack_public_path__ + "img/facebook.b930dad7.svg";